import React, { memo } from 'react';
import { StyledLoading } from 'adapter/in/common/components/widgets/LoadingMessage/style';
import { Loading } from '@dexma/ui-components';
import i18n from 'asset/translation';

type LoadingMessagePropsType = {
    width: number;
    height: number;
};

const getSize = (width: number, height: number): number => {
    const loadingIconRelation = 35;

    const applyCorrection = (property: number) => {
        const proportion = height / width;
        const basicSize = width / property;

        return basicSize * Math.min(proportion, 0.8);
    };

    const loadingIconSize = applyCorrection(loadingIconRelation);

    return loadingIconSize;
};

const LoadingMessage = (props: LoadingMessagePropsType) => {
    const { width, height } = props;
    const loadingIconSize = getSize(width, height);

    return (
        <StyledLoading data-testid='loading-message'>
            <div>
                <Loading isLoading size={loadingIconSize} />{' '}
            </div>
            <span>{i18n.t('common.loadingData')}</span>
        </StyledLoading>
    );
};

export default memo(LoadingMessage);
